import { Link } from "react-router-dom";
import {
  PageHeader,
  DataTable,
  ErrorState,
  LoadingState,
  PermissionDenied,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export default function UsersPage() {
  const result =
    useHubResource<
      { id: string; displayName: string; role: string; status: string }[]
    >("/hub/users");
  return (
    <section className="hub-page">
      <PageHeader
        title="Usuarios"
        subtitle="Operadores de tu organización · primeros 100 registros"
      >
        <Link to="/sistema/permisos">Mis permisos →</Link>
      </PageHeader>
      {result.state === "denied" ? (
        <PermissionDenied />
      ) : result.state === "error" ? (
        <ErrorState retry={result.retry} />
      ) : !result.data ? (
        <LoadingState />
      ) : (
        <DataTable
          rows={result.data}
          rowKey={(row) => row.id}
          columns={[
            { title: "Nombre", render: (row) => row.displayName },
            { title: "Rol actual", render: (row) => row.role },
            { title: "Estado", render: (row) => row.status },
          ]}
        />
      )}
    </section>
  );
}
